import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const bloqueioManualRepository = createRepository({
  path: 'bloqueio-manual-kmm',
  restApi,
  queryTransform: {
    cpfcnpj: query.likeDigits('cpfcnpj'),
    createdAt: query.gte('createdAt'),
    ...paginate
  }
})

bloqueioManualRepository.desbloquear = (id, data) => {
  return restApi.post(`bloqueio-manual-kmm/${id}/desbloqueio/`, data)
}

bloqueioManualRepository.bloquear = (id, data) => {
  return restApi.post(`bloqueio-manual-kmm/${id}/bloqueio/`, data)
}

bloqueioManualRepository.getHistorico = id => {
  return restApi.get(`bloqueio-manual-kmm/${id}/historico`)
}

export default bloqueioManualRepository
